"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _InvertingButton = require("../InvertingButton");

var styles = {
  root: Object.assign({}, _InvertingButton.styles.root, {
    width: '35px',
    borderRadius: '2rem',
    padding: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fill: function fill(_ref) {
      var outlineColor = _ref.outlineColor;
      return outlineColor;
    },
    '&:hover': {
      fill: function fill(_ref2) {
        var backgroundColor = _ref2.backgroundColor;
        return backgroundColor;
      }
    }
  }),
  icon: {
    height: '18px',
    width: '18px',
    pointerEvents: 'none'
  },
  disabled: {
    pointerEvents: 'none',
    opacity: 0.5
  }
};
var _default = styles;
exports["default"] = _default;